export default __webpack_public_path__ + "static/media/ic-crops-leek.852fb05f.svg";